var map = {
	"./amethyst.svg": 587,
	"./black_onyx.svg": 588,
	"./blue_sapphire.svg": 589,
	"./cubic_zirconia.svg": 590,
	"./diamond.svg": 591,
	"./emerald.svg": 592,
	"./garnet.svg": 593,
	"./labradorite.svg": 594,
	"./lapis_lazuli.svg": 595,
	"./malachite.svg": 596,
	"./moonstone.svg": 597,
	"./mother_of_pearl.svg": 598,
	"./opal.svg": 599,
	"./pink_sapphire.svg": 600,
	"./quartz.svg": 601,
	"./rose_quartz.svg": 602,
	"./ruby.svg": 603,
	"./tiger_eye.svg": 604,
	"./tourmaline.svg": 605,
	"./turquoise.svg": 606,
	"./white_sapphire.svg": 607,
	"./yellow_sapphire.svg": 608,
	"./zircon.svg": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 586;